const initialState = {
  permissionsSCO: null
}

const permissionsSCO = (state = initialState, action) => {
  switch (action.type) {
    case "PERMISSIONS_SCO":
      return { ...state, permissionsSCO: action.val }
    default:
      return state
  }
}
export default permissionsSCO
